import { BadgeCheck } from "lucide-react";
import { isVerifiedNewsroom } from "../lib/verifiedNewsrooms";

/**
 * VerifiedBadge — small gold pill that surfaces next to a source/channel name
 * when it matches a known verified newsroom (wire services, broadcasters,
 * prestige print). Helps readers tell newsroom content from random YouTube.
 */
export default function VerifiedBadge({ name, compact = false, testId }) {
  if (!isVerifiedNewsroom(name)) return null;
  if (compact) {
    return (
      <span
        title="Verified newsroom on Newseze"
        className="inline-flex items-center text-[var(--gold)]"
        data-testid={testId || "verified-newsroom-badge-compact"}
      >
        <BadgeCheck size={12} strokeWidth={2.5} />
      </span>
    );
  }
  return (
    <span
      title="Verified newsroom on Newseze — wire services, broadcasters, and prestige newsrooms."
      className="inline-flex items-center gap-0.5 text-[9px] uppercase tracking-[0.12em] font-black text-[#1d1303] bg-[var(--gold)] px-1.5 py-0.5 rounded"
      data-testid={testId || "verified-newsroom-badge"}
    >
      <BadgeCheck size={10} strokeWidth={2.5} /> Verified
    </span>
  );
}
